import(/* webpackMode: "eager" */ "/codebuild/output/src286783123/src/apps/junonkuji/src/components/errors/ErrorPage/ErrorPage.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src286783123/src/apps/junonkuji/src/styles/modules/utils.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src286783123/src/apps/junonkuji/src/components/form/LinkButton/LinkButton.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src286783123/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src286783123/src/node_modules/next/font/google/target.css?{\"path\":\"src/lib/font.ts\",\"import\":\"Montserrat\",\"arguments\":[{\"weight\":\"700\",\"subsets\":[\"latin\"],\"display\":\"swap\",\"fallback\":[\"sans-serif\"]}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src286783123/src/apps/junonkuji/src/styles/modules/layout.module.scss");
